import React, { FC } from "react";
import { Tooltip } from "antd";
import { NormalizationErrorType } from "../../../../annotation/interfaces/annotation";
import useEntityTextVisual from "../../hooks/useEntityTextVisual";

type Props = {
  value: string;
  normalizedValue: string | undefined;
  // SideControls specific props
  showLabels?: boolean;
  showNormalizedValue?: boolean;
  requiresAttention?: boolean;
  errorType?: NormalizationErrorType;
  isTableMode: boolean;
  cellClasses?: string;
};

const EntityTextVisual: FC<Props> = ({
  value,
  normalizedValue,
  showLabels = true,
  showNormalizedValue = true,
  requiresAttention = false,
  errorType,
  isTableMode,
  cellClasses = "",
}) => {
  const {
    textValue,
    showValueTooltip,
    showNormalizedValueTooltip,
    normalizedClassName,
    labeledClassName,
    labeledWithoutNormalizedClassName,
    singleColumnTooltip,
    fallbackData,
  } = useEntityTextVisual({
    value,
    normalizedValue,
    showLabels,
    showNormalizedValue,
    requiresAttention,
    errorType,
    cellClasses,
  });

  if (isTableMode) {
    return (
      <div className={`entity-visual__container--table`}>
        <div className={`entity-visual__text ${cellClasses}`}>{textValue}</div>
      </div>
    );
  }

  if (!showNormalizedValue) {
    return (
      <Tooltip placement="top" title={singleColumnTooltip}>
        <div className="entity-visual__container--side">
          <div className={labeledWithoutNormalizedClassName}>{value}</div>
        </div>
      </Tooltip>
    );
  }

  if (!value || !normalizedValue) {
    return (
      <Tooltip placement="top" title={fallbackData.tooltip}>
        <div className="entity-visual__container--side">
          <div className={labeledWithoutNormalizedClassName}>
            {fallbackData.tooltipValue}
          </div>
        </div>
      </Tooltip>
    );
  }

  // Always show original › result (no mini-headers) — consistent with the
  // previous behaviour. The "what/why" lives on the pill next to the field name.
  return (
    <div className="entity-visual__container--side entity-visual__container--transformed">
      <Tooltip placement="top" title={showValueTooltip ? value : null}>
        <div className={`${labeledClassName} entity-visual__from`}>{value}</div>
      </Tooltip>

      <span className="entity-visual__chevron">
        <i className="bi bi-chevron-right" />
      </span>

      <Tooltip
        placement="top"
        title={showNormalizedValueTooltip ? normalizedValue : null}
      >
        <div className={normalizedClassName}>{normalizedValue}</div>
      </Tooltip>
    </div>
  );
};

export default EntityTextVisual;
